import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom-v5-compat";

import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

import { ProviderSSO } from "../auth/types";
import useAuthUser from "./useAuthUser";

export default function useAuthWithCredentials() {
  const authUser = useAuthUser();
  const isiOS = isNativeAppiOS();

  const isAuthStarted = useRef(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let credentials = searchParams.get("credentials");
    let isNewUser = searchParams.get("isNewUser") === "true";
    let provider = searchParams.get("provider") as ProviderSSO;

    if (credentials && provider && !isAuthStarted.current && isiOS) {
      isAuthStarted.current = true;

      authUser({ credentials, provider, isNewUser });
    }
  }, [searchParams, authUser, isiOS]);
}
